import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest, HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, from, throwError } from 'rxjs';
import { UserService } from './services/user.service';
import { BusyService } from './services/busy.service';
import { finalize, catchError, switchMap } from 'rxjs/operators';

@Injectable()
export class TokenInterceptor implements HttpInterceptor {
  private authorization: string;
  private accept = 'application/json';
  private responseType = 'json';

  constructor(private userService: UserService, private busyService: BusyService) {}

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    this.authorization = `Bearer ${this.userService.getAccessToken()}`;

    if (request.method === 'POST' && request.body instanceof FormData) {
      this.accept = 'multipart/form-data';
    }

    if (request.method !== 'GET') {
      this.busyService.onStarted(request);
    }

    const headers = {
      Authorization: this.authorization,
      Accept: this.accept,
      responseType: this.responseType,
    };

    return next
      .handle(
        request.clone({
          setHeaders: { ...headers },
        })
      )
      .pipe(
        catchError((error: HttpErrorResponse) => {
          if (error.error instanceof Blob) {
            return from(error.error.text()).pipe(
              switchMap((text) => {
                try {
                  const json = JSON.parse(text);
                  const modifiedError = new HttpErrorResponse({
                    error: json,
                    headers: error.headers,
                    status: error.status,
                    statusText: error.statusText,
                    url: error.url || undefined,
                  });
                  return throwError(() => modifiedError);
                } catch {
                  return throwError(() => error);
                }
              })
            );
          }
          return throwError(() => error);
        }),
        finalize(() => {
          this.busyService.onFinished(request);
        })
      );
  }
}
